var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('md-card',{staticClass:"md-elevation-1"},[_c('md-card-header',[_c('div',{staticClass:"title"},[_c('p',[_vm._v("404")]),_c('p',[_vm._v("Not Found!")])])]),_c('md-card-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }